export const numberWithSpaces = (value: string) =>
  value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
